import {createReducer} from "redux-act";
import {RequestState} from "modules";
import {
	addVoteAction,
	selectMatchAction,
	addVoteActionSuccess,
	addVotesActionSuccess,
	setConfirmModalState,
	addVoteActionFailed,
} from "apps/BUDWEISERPOTM/modules/actions/votes";
import {keyBy} from "lodash";

interface IVotesReducer {
	votes: Record<string, ReturnType<typeof addVotesActionSuccess>["payload"]["votes"][number]>;
	selectedMatchId: ReturnType<typeof selectMatchAction>["payload"];
	requestState: RequestState;
	confirmModalState: ReturnType<typeof setConfirmModalState>["payload"];
}

const initial: IVotesReducer = {
	votes: {},
	selectedMatchId: null,
	requestState: RequestState.IDLE,
	confirmModalState: null,
};

export const votes = createReducer<IVotesReducer>({}, initial)
	.on(addVoteAction, (state, payload) => ({
		...state,
		requestState: RequestState.Requested,
	}))
	.on(addVoteActionSuccess, (state, payload) => ({
		...state,
		requestState: RequestState.Received,
		votes: {
			...state.votes,
			[payload.gameId]: payload,
		},
	}))
	.on(addVoteActionFailed, (state, payload) => ({
		...state,
		requestState: RequestState.Received,
	}))
	.on(addVotesActionSuccess, (state, payload) => ({
		...state,
		requestState: RequestState.Received,
		votes: keyBy(payload.votes, "gameId"),
	}))
	.on(selectMatchAction, (state, payload) => ({
		...state,
		selectedMatchId: payload,
	}))
	.on(setConfirmModalState, (state, payload) => ({
		...state,
		confirmModalState: payload,
	}));
